if (!customElements.get('recipient-product-slider')) {
  class RecipientProductSlider extends HTMLElement {
    connectedCallback() {
      this.eventController?.abort();
      this.eventController = new AbortController();
      this.buttons = Array.from(this.querySelectorAll('[data-recipient-filter]'));
      this.items = Array.from(this.querySelectorAll('[data-recipient-values]'));
      this.emptyMessage = this.querySelector('.pra-v2-recipient-products__empty');
      this.buttons.forEach((button) => button.addEventListener('click', () => this.toggleFilter(button), { signal: this.eventController.signal }));
      this.setupSlider();
    }

    disconnectedCallback() {
      this.eventController?.abort();
      this.querySelector('.pra-v2-recipient-products__track')?.classList.remove('is-dragging');
    }

    setupSlider() {
      const track = this.querySelector('.pra-v2-recipient-products__track');
      if (!track) return;
      const { signal } = this.eventController;

      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let dragged = false;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        dragged = false;
      }, { signal });

      track.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        const distance = event.clientX - startX;
        if (!dragged && Math.abs(distance) > 4) {
          dragged = true;
          track.setPointerCapture(pointerId);
          track.classList.add('is-dragging');
        }
        if (!dragged) return;
        track.scrollLeft = startScrollLeft - distance;
      }, { signal });

      const finishDrag = (event) => {
        if (event.pointerId !== pointerId) return;
        if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
        pointerId = null;
        track.classList.remove('is-dragging');
      };

      track.addEventListener('pointerup', finishDrag, { signal });
      track.addEventListener('pointercancel', finishDrag, { signal });
      track.addEventListener('lostpointercapture', () => {
        pointerId = null;
        track.classList.remove('is-dragging');
      }, { signal });

      track.addEventListener(
        'click',
        (event) => {
          if (!dragged) return;
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        },
        { capture: true, signal }
      );

      track.addEventListener(
        'wheel',
        (event) => {
          if (Math.abs(event.deltaY) <= Math.abs(event.deltaX) || track.scrollWidth <= track.clientWidth) return;
          event.preventDefault();
          track.scrollLeft += event.deltaY;
        },
        { passive: false, signal }
      );
    }

    toggleFilter(button) {
      const wasSelected = button.getAttribute('aria-pressed') === 'true';
      const selectedValue = wasSelected ? '' : button.dataset.recipientFilter;

      this.buttons.forEach((candidate) => {
        candidate.setAttribute('aria-pressed', candidate === button && !wasSelected ? 'true' : 'false');
      });

      let visibleCount = 0;
      this.items.forEach((item) => {
        const values = (item.dataset.recipientValues || '').split('|');
        const visible = !selectedValue || values.includes(selectedValue);
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (this.emptyMessage) this.emptyMessage.hidden = visibleCount !== 0;
      const track = this.querySelector('.pra-v2-recipient-products__track');
      if (track) track.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }

  customElements.define('recipient-product-slider', RecipientProductSlider);
}
